<template>
  <v-stepper v-model="step" v-if="!loadingAppProgress">
    <v-stepper-header>
  <!-- STEP 1 -->
      <v-stepper-step
        editable
        step="1"
        @click="changeStep('1')"
      >
        Our Services
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step
        editable
        step="2"
        @click="changeStep('2')"
      >
        Your Program
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step
        editable
        step="3"
        @click="changeStep('3')"
      >
        Your Applications <span v-if="$store.state.appAmount">({{ $store.state.appAmount }})</span>
      </v-stepper-step>
    </v-stepper-header>
    <v-stepper-items>
      <v-stepper-content step="1">
        <v-card
          class="mb-4"
          height="auto"
          flat
        >
          <v-card-title class="card-title">Add Services or select a Full Program</v-card-title>
          <v-card-text>
            <v-card flat class="white pt-2">
                <v-card-text>
                  <v-expansion-panels
                    hover
                    focusable
                    multiple
                    v-model="panel"
                  >
                    <v-expansion-panel
                        v-for="type_item in $store.state.types"
                      :key="type_item.type_order"
                    >
                      <v-expansion-panel-header
                        ripple
                        class="px-0 px-sm-6"
                      >
                        <v-col cols="12">
                          <v-card-subtitle>
                            <v-icon large class="my-10"> 
                              {{type_item.icon}}
                            </v-icon>
                            {{type_item.text}}
                          </v-card-subtitle>
                        </v-col>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div class="d-flex justify-start flex-row flex-wrap">
                          <div
                            v-for="select_item in create_select_items(type_item.type_id)"
                            :key="select_item.service_number"
                          >
                            <v-card class="elevation-3 flex d-flex flex-column rounded-lg ma-2" max-width="300px">
                              <v-card-text class="ma-0 pa-0">
                                <v-img
                                  :src="getImage(select_item.image)"
                                  class="white--text align-end rounded-lg"
                                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                                  max-width="300px"
                                  lazy-src="../assets/lazy-thumbnail.webp"
                                >
                                  <v-card-title class="white--text">
                                    {{ select_item.name }} 
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      v-if="select_item.info_link" 
                                      fab 
                                      color="ppc_pink" 
                                      x-small 
                                      :href="select_item.info_link" 
                                      target="_blank"
                                      absolute
                                      right
                                      top
                                      class="mt-7"
                                    >
                                      <v-icon color="white">mdi-information-variant</v-icon>
                                    </v-btn>
                                  </v-card-title>
                                </v-img>
                                <v-row no-gutters class="ma-4">
                                  <v-col cols="12" class="my-4 py-0">
                                    <span v-if="select_item.priceFrom"> From <span class="black--text display-1"> {{select_item.currency}}{{select_item.priceFrom.toFixed(2)}} </span> </span>
                                    <span v-else-if="select_item.price && !select_item.varPrice"> <span class="black--text display-1"> {{select_item.currency}}{{select_item.price.toFixed(2)}} </span> {{select_item.price_desc}} </span>
                                    <span v-else-if="select_item.varPrice && !select_item.price"> <span class="black--text display-1"> {{select_item.currency}}{{(select_item.min_duration * select_item.varPrice).toFixed(2)}} </span> {{select_item.price_desc}} </span>
                                    <span v-else-if="select_item.varPrice && select_item.price"> <span class="black--text display-1"> {{select_item.currency}}{{(select_item.price + (select_item.min_duration * select_item.varPrice)).toFixed(2)}} </span> {{select_item.price_desc}} </span>
                                    <div v-if="select_item.promo_text" class="font-weight-black button ml-12"> {{select_item.promo_text}}</div>
                                    <div class="pos_absolute"><v-icon x-large v-if="select_item.promo_text"> $vuetify.icons.icon_sale </v-icon></div>
                                    <v-divider></v-divider>
                                  </v-col>
                                  <v-col cols="12" class="my-4 py-0" v-if="select_item.min_duration && select_item.duration_type !== 'fixed'">
                                    <v-card-subtitle class="ppc_darkgreen--text mb-0 pb-0 ml-0 pl-0">Minimal duration</v-card-subtitle>
                                    <span>{{select_item.min_duration}} {{select_item.duration_text}} </span>
                                    <v-divider></v-divider>
                                  </v-col>
                                  <v-col cols="12" class="my-4 py-0" v-if="select_item.duration_type === 'fixed'">
                                    <v-card-subtitle class="ppc_darkgreen--text mb-0 pb-0 ml-0 pl-0">Duration</v-card-subtitle>
                                    <span> {{select_item.duration}} {{select_item.duration_text}} </span>
                                    <v-divider></v-divider>
                                  </v-col>
                                  <v-col cols="12" class="my-4 py-0" v-if="select_item.min_level_spanish">
                                    <v-card  
                                      flat
                                    >
                                      <v-card-subtitle class="ppc_darkgreen--text mb-0 pb-0 ml-0 pl-0">Initial Spanish level</v-card-subtitle>
                                      <v-card-text> {{select_item.min_level_spanish}} </v-card-text>
                                      <v-divider></v-divider>
                                    </v-card>
                                  </v-col>
                                  <v-col  v-if="select_item.desc_acc" cols="12" class="my-1 py-0">
                                    <v-card
                                      flat
                                    >
                                      <v-card-subtitle class="ppc_darkgreen--text my-0 pa-0 pt-2">Accommodation</v-card-subtitle>
                                      <v-card-text class="pb-0" v-html="select_item.desc_acc"></v-card-text>
                                      <v-divider></v-divider> 
                                    </v-card>
                                  </v-col>
                                  <v-col  v-if="select_item.desc_study" cols="12" class="my-1 py-0">
                                    <v-card
                                      flat
                                    >
                                      <v-card-subtitle class="ppc_darkgreen--text my-0 pa-0 pt-2">Study</v-card-subtitle>
                                      <v-card-text class="pb-0" v-html="select_item.desc_study"></v-card-text>
                                      <v-divider></v-divider> 
                                    </v-card>
                                  </v-col>
                                  <v-col  v-if="select_item.desc_project" cols="12" class="my-1 py-0">
                                    <v-card
                                      flat
                                    >
                                      <v-card-subtitle class="ppc_darkgreen--text my-0 pa-0 pt-2">Project</v-card-subtitle>
                                      <v-card-text class="pb-0" v-html="select_item.desc_project"></v-card-text>
                                      <v-divider></v-divider> 
                                    </v-card>
                                  </v-col>
                                  <v-col  v-if="select_item.desc_start" cols="12" class="my-1 py-0">
                                    <v-card
                                      flat
                                    >
                                      <v-card-subtitle class="ppc_darkgreen--text my-0 pa-0 pt-2">Start</v-card-subtitle>
                                      <v-card-text class="pb-0" v-html="select_item.desc_start"></v-card-text>
                                      <v-divider></v-divider> 
                                    </v-card>
                                  </v-col>
                                  <v-col  v-if="select_item.desc_incl" cols="12" class="my-1 py-0">
                                    <v-card
                                      flat
                                    >
                                      <v-card-subtitle class="ppc_darkgreen--text my-0 pa-0 pt-2">Includes</v-card-subtitle>
                                      <v-card-text class="pb-0" v-html="select_item.desc_incl"></v-card-text>
                                      <v-divider></v-divider> 
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="ppc_pink" text ripple @click="select_service(select_item.service_number)">Add</v-btn>
                              </v-card-actions>
                            </v-card>
                          </div>
                        </div>
                        
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card-text>
              </v-card>
          </v-card-text>
          
        </v-card>
      </v-stepper-content>
<!-- STEP 2 -->
      <v-stepper-content step="2">
        <v-card
          class="mb-12"
          flat
        >
        <v-card-title class="card-title"><span :key="rendererKeyTotalPrice">Total price: {{ totalPrice() }} USD</span></v-card-title>
        <v-spacer></v-spacer>
        
        <v-expansion-panels
          hover
          focusable
          multiple
          v-model="panel"
        >
          <v-expansion-panel
            v-for="(service, indexServices) in services"
            :key="indexServices"
          >
            <div v-if="service.application_id===null">
              <v-expansion-panel-header
                ripple
                class="px-0 px-sm-6"
              >
              <v-container fluid>
                  <v-row>
                    <v-col cols="12" lg="4" class="pt-5">
                      <span v-if="service.service_number">
                        <h3 class="ppc_darkgreen--text"><v-icon class="mr-4"> {{ service.icon }} </v-icon>{{ service.name }}</h3>
                      </span>
                    </v-col>
                    <v-col cols="12" lg="8">
                      <v-fade-transition leave-absolute>
                        <span
                          class="text--secondary"
                        >
                          <v-row
                            dense
                            :key="rendererKeyPanelHeader"
                          >
                            <v-col cols="12" sm="6" md="2" class="pt-4"><span class="font-italic">From:</span> <span>{{ formattedDate(service.start) || '(to be planned)' }}</span> </v-col>
                            <v-col cols="12" sm="6" md="2" class="pt-4"><span class="font-italic">To:</span> <span>{{ formattedDate(service.end) || '(to be planned)' }}</span> </v-col>
                            <v-col cols="12" sm="6" md="2" class="pt-4"><span class="font-italic">Duration:</span> {{ service.duration || 'Not set' }} {{ service.duration_text }}</v-col>
                            <v-col cols="12" sm="6" md="2" class="pt-4">
                              <span class="font-italic">Price: </span><span v-if="service.servicePrice">{{ service.currency }}{{ service.servicePrice.toFixed(2) || 'Not set' }} </span>
                              <span v-if="service.currency === 'S/.'" class="ml-2">
                                (${{ priceInDollars(service.servicePrice) }})
                              </span>
                            </v-col>
                            <v-col cols="12" sm="6" md="2">
                              <v-tooltip
                                left
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn 
                                    class="my-0 ml-16 pa-0"
                                    v-bind="attrs"
                                    v-on="on" 
                                    icon
                                    color="grey darken-3"
                                    @click="remove(service.id)"
                                  >
                                    <v-icon>
                                        $vuetify.icons.icon_delete
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>Remove {{ service.name }} from program</span>
                              </v-tooltip>
                            </v-col>
                            <v-col cols="12" sm="6" md="2" class="my-3">
                              (click to open/close)
                            </v-col>
                          </v-row>
                        </span>
                      </v-fade-transition>
                    </v-col>
                  </v-row>
                </v-container>
              </v-expansion-panel-header>
              <v-expansion-panel-content>

                <v-container fluid>
                    <!-- image & description -->
                    <v-card
                      flat
                      class="mx-0 my-3 mx-sm-3 float-left"
                      max-width="300px"
                      width="100%"
                    >
                      
                      <v-card 
                        flat 
                        color="#eee"
                      >
                        <v-card-text class="ma-0 pa-0">
                          <v-img
                            :src="getImage(service.image)"
                            class="white--text align-end mb-5"
                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                          >
                            <v-btn 
                              v-if="service.info_link" 
                              fab 
                              color="ppc_pink" 
                              x-small 
                              :href="service.info_link"
                              target="_blank"
                              top
                              right
                              absolute
                              class="mt-7"
                            >
                              <v-icon color="white">mdi-information-variant</v-icon>
                            </v-btn>
                            <v-card-title v-text="service.name" class="white--text"></v-card-title>
                          </v-img>
                          <p v-if="service.min_duration">
                            <v-card-subtitle class="ppc_darkgreen--text">Minimal duration</v-card-subtitle>
                            <v-card-text> 
                              {{service.min_duration}} {{service.duration_text}} 
                              <v-divider></v-divider> 
                            </v-card-text>
                          </p>
                          <p v-if="service.min_level_spanish">
                            <v-card-subtitle class="ppc_darkgreen--text">Initial Spanish level</v-card-subtitle>
                            <v-card-text> {{service.min_level_spanish}} <v-divider></v-divider> </v-card-text>
                          </p>
                          <p v-if="service.duration_type === 'fixed'">
                            <v-card-subtitle class="ppc_darkgreen--text">Duration</v-card-subtitle>
                              <v-card-text>{{service.duration}} {{service.duration_text}} </v-card-text>
                              <v-divider></v-divider>
                          </p>
                          <div  v-if="service.desc_acc">
                            <p
                              flat
                            >
                              <v-card-subtitle class="ppc_darkgreen--text">Accommodation</v-card-subtitle>
                              <v-card-text class="pb-0" v-html="service.desc_acc"></v-card-text>
                            </p>
                            <v-divider></v-divider>
                          </div>
                          <div  v-if="service.desc_study">
                            <p
                              flat
                            >
                              <v-card-subtitle class="ppc_darkgreen--text">Study</v-card-subtitle>
                              <v-card-text class="pb-0" v-html="service.desc_study"></v-card-text>
                            </p>
                            <v-divider></v-divider>
                          </div>
                          <div  v-if="service.desc_project">
                            <p
                              flat
                            >
                              <v-card-subtitle class="ppc_darkgreen--text">Project</v-card-subtitle>
                              <v-card-text class="pb-0" v-html="service.desc_project"></v-card-text>
                            </p>
                            <v-divider></v-divider>
                          </div>
                          <div  v-if="service.desc_start">
                            <p
                              flat
                            >
                              <v-card-subtitle class="ppc_darkgreen--text">Start</v-card-subtitle>
                              <v-card-text class="pb-0" v-html="service.desc_start"></v-card-text>
                            </p>
                            <v-divider></v-divider>
                          </div>
                          <div  v-if="service.desc_incl">
                            <p
                              flat
                            >
                              <v-card-subtitle class="ppc_darkgreen--text">Includes</v-card-subtitle>
                              <v-card-text class="pb-0" v-html="service.desc_incl"></v-card-text>
                            </p>
                            <v-divider></v-divider>
                          </div>
                        </v-card-text>
                      </v-card>
                    
                    </v-card>
                    

                    <!-- Period & dates -->
                    <v-card 
                      elevation="3" 
                      class="mx-0 my-3 mx-sm-3 pa-4 float-left"
                      max-width="250px"
                      v-if="service.allowedStartDays"
                    >
                      <v-card-title>Period</v-card-title>
                      <v-card-text>
                        <v-menu
                          transition="scale-transition"
                          offset-y
                          class="my-5"
                          max-width="100%"
                          :key="rendererKeyDateStart"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              label="from"
                              v-bind="attrs"
                              prepend-icon="mdi-calendar"
                              :value="formattedDate(service.start)"
                              v-on="on"
                              :disabled="!service.service_number"
                              @click:clear="clearStartDate(indexServices)"
                              @click="changeAllowedStartDays(service.service_number)"
                              clearable
                              readonly
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            :value="service.start"
                            no-title
                            scrollable
                            :allowed-dates="getStartDays"
                            :min="nowDate"
                            @change="calcDates('start', indexServices, $event)"
                          >
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          transition="scale-transition"
                          offset-y
                          class="my-5"
                          max-width="100%"
                          :key="rendererKeyDateEnd"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              label="until"
                              v-bind="attrs"
                              prepend-icon="mdi-calendar"
                              :value="formattedDate(service.end)"
                              v-on="on"
                              :disabled="disabledEndDate(service.id, indexServices)"
                              @click:clear="clearEndDate(indexServices)"
                              @click="changeAllowedEndDays(service.service_number)"
                              clearable
                              readonly
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            :value="service.end"
                            no-title
                            scrollable
                            :allowed-dates="getEndDays"
                            :min="getMinEndDate(indexServices)"
                            @change="calcDates('end', indexServices, $event)"
                          >
                          </v-date-picker>
                        </v-menu>
                        <v-slider
                          :value="service.duration"
                          step="1"
                          ticks
                          tick-size="4"
                          thumb-label="always"
                          :min="service.min_duration"
                          :max="service.week_slider"
                          hint="Duration in weeks"
                          persistent-hint
                          thumb-color="ppc_pink"
                          track-color="ppc_grey"
                          @change="calcDates('duration', indexServices, $event)"
                          :disabled="!service.service_number || fixedDuration"
                          v-if="service.week_slider"
                          class="mt-8"
                          :key="rendererKeySlider"
                        ></v-slider>
                      </v-card-text>
                      <v-card-subtitle v-if="service.week_slider">Drag the slider to adjust the weeks</v-card-subtitle>
                    </v-card>

                      <!-- radio and options in services -->
                      <v-card
                        flat
                        v-for="(radio_group, j) in radioGroups_filtered(service.id)"
                        :key="j + radio_group.radio_group_id"
                        class="mx-0 my-3 mx-sm-3 float-left"
                      >
                        <v-card
                          elevation="3"
                          class="pa-4"
                        >
                          <v-card-title>
                            {{radio_group.radio_group_question}}
                            <v-spacer></v-spacer>
                            <v-btn 
                              v-if="radio_group.info_link" 
                              fab 
                              color="ppc_pink" 
                              x-small 
                              :href="radio_group.info_link"
                              target="_blank"
                              class="mx-2"
                            >
                              <v-icon color="white">mdi-information-variant</v-icon>
                            </v-btn>
                          </v-card-title>
                          <v-card-text>
                            <v-radio-group 
                              :value="radio_group.radio_group_value"
                              @change="setRadios(radio_group.radio_group_id, service.id, indexServices, $event)"
                              column
                            >
                              <v-radio
                                v-for="(radio_option, k) in radioOptions_filtered(radio_group.radio_group_id)"
                                :key="k"
                                :label="radio_option.label"
                                :value="radio_option.label"
                                class="my-0 py-0"
                              ></v-radio>
                            </v-radio-group>
                          </v-card-text>
                        </v-card>
                      </v-card>
                    
                      <v-card 
                        elevation="3"
                        v-if="options_filtered(service.id).length > 0"
                        class="mx-0 my-3 mx-sm-3 float-left"
                      >
                        <v-card-title>
                          Options
                        </v-card-title>
                        <v-card-text>
                          <v-card
                            flat
                            v-for="(option, j) in options_filtered(service.id)"
                            :key="j + option.option_id"
                          >
                            <v-checkbox
                              :input-value="option.selected"
                              :label="option.option_question"
                              @change="setOptions(option.option_id, service.id, indexServices, $event)"
                              class="my-0 py-0"
                            ></v-checkbox>
                          </v-card>
                        </v-card-text>
                      </v-card>
                </v-container>
              </v-expansion-panel-content>
            </div>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-card-actions>
            <v-btn
              color="primary"
              @click="changeStep('1');"
            >
              Add Services to this Program
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="submit();"
            >
              Apply Program & Wrap Up
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-stepper-content>
<!-- STEP 3 -->
      <v-stepper-content step="3">
        <v-card-title v-if="!statusLoggedIn">
          Please Sign In to check your Applications and fill in the Application Form
          <v-btn class="mx-4" color="primary" type="submit" @click="openDialog_sign_in(true)">
            Sign in
            <span slot="loader" class="custom-loader">
                <v-icon light>mdi-cached</v-icon>
            </span>
          </v-btn>
        </v-card-title>
        <v-card
          class="mb-12"
          flat
          :disabled="!statusLoggedIn"
        >
          <v-toolbar 
            width="100%"
            color="ppc_darkgreen"
            style="color: white;"
            flat
          >
            <v-toolbar-title>Applications & Invoices</v-toolbar-title>
          </v-toolbar>
          <v-card-text v-if="statusLoggedIn">
            <div v-if="applications.length>0" class="d-flex flex-column align-center">
              <v-card
                v-for="application in applications"
                :key="application.id"
                class="d-flex flex-column justify-between my-2"
                max-width="1100px"
                width="100%"
              >
                <div class="d-flex flex-row flex-wrap justify-center justify-md-right">
                  <div class="d-flex flex-column">
                    <v-card-title>
                      <div v-if="getServicesApplied(application.id).length > 0">
                        <v-list-item-title>
                          <span v-for="(service, i) in getServicesApplied(application.id)" :key="i">
                            <span class="ppc_pink--text my-2 text-wrap text-body-1 text-sm-h5">{{service.name}}</span>
                            <span v-if="i != getServicesApplied(application.id).length - 1">, </span>
                          </span>
                        </v-list-item-title>
                      </div>
                      <div v-else>
                        <v-list-item-title>
                          <h2 class="grey--text">Application</h2>
                        </v-list-item-title>
                      </div>
                    </v-card-title>
                  </div>
                  <v-spacer></v-spacer>
                  <div v-if="calcStatus(application.id) > 0">
                    <v-chip :color="getStatus(calcStatus(application.id)).color" class="white--text ma-4"> {{getStatus(calcStatus(application.id)).name}} </v-chip>
                  </div>
                </div>
                <v-card-title v-if="cvRequired(application.id)>0 || passportRequired(application.id)>0 || spanishTestRequired(application.id)>0">What we need from you:</v-card-title>
                <v-card flat class="d-flex flex-row flex-wrap justify-center justify-md-start" :key="rendererKeyUploadPanels">
                  <v-card class="d-flex flex-column align-start my-1 ma-sm-3 ma-md-5 pa-5 md12" v-if="cvRequired(application.id)>0" width="320px">
                    <v-card flat><h2 class="grey--text"><v-icon size="40" class="mr-2">mdi-text-box</v-icon>Curriculum Vitae</h2></v-card>
                    <v-card flat class="mx-auto my-5">
                      <div v-if="calcStatus(application.id) === 12">
                        <v-card-text>Please add your cv below in the Application Form, to help us to find the best project for you</v-card-text>
                      </div>
                      <div v-else-if="calcStatus(application.id) === 10">
                        <v-card-text>Thank you for adding your cv! Please wait until we've checked your cv</v-card-text>
                      </div>
                    </v-card>
                    <v-card v-if="getUploadInfoType('cv').length > 0" flat class="mx-auto my-5">
                      <div v-if="getUploadInfoType('cv')[0].approved" class="align-self-center">
                        <v-icon color="ppc_darkgreen">mdi-check</v-icon>
                        <strong>cv approved!</strong>
                      </div>
                    </v-card>
                  </v-card>
                  <v-card class="d-flex flex-column align-start my-1 my-1 ma-sm-3 ma-md-5 pa-5" v-if="passportRequired(application.id)>0" width="320px">
                    <v-card flat>
                      <h2 class="grey--text"><v-icon size="40" class="mr-2">mdi-passport</v-icon>Passport Scan</h2>
                    </v-card>
                    <v-card flat class="mx-auto my-5">
                      <div v-if="calcStatus(application.id) === 11">
                        <v-card-text>Please add your pasport scan below in the Application Form, so we can make your Machu Picchu reservation</v-card-text>
                      </div>
                      <div v-else-if="calcStatus(application.id) === 10">
                        <v-card-text>Thank you for adding your pasport! Please wait until we've checked your scan</v-card-text>
                      </div>
                    </v-card>
                    <v-card v-if="getUploadInfoType('passport').length > 0" flat class="mx-auto my-5">
                      <div v-if="getUploadInfoType('passport')[0].approved" class="align-self-center">
                        <v-icon color="ppc_darkgreen">mdi-check</v-icon>
                        <strong>passport approved!</strong>
                      </div>
                    </v-card>
                  </v-card>
                  <v-card class="d-flex flex-column my-1 my-1 ma-sm-3 ma-md-5 pa-5" v-if="spanishTestRequired(application.id)>0" width="320px">
                    <v-card flat><h2 class="grey--text"><v-icon size="40" class="mr-2">mdi-file-document-edit</v-icon>Spanish Test</h2></v-card>
                    <v-spacer></v-spacer>
                    <v-card flat class="align-self-center">
                      <v-btn 
                        color="success" 
                        dark 
                        small 
                        target="_blank" 
                        href="https://docs.google.com/forms/d/e/1FAIpQLScV-3VQDsf8cHMz0ZTl9fTMbw1j-DG4Bth_DrxlXbVuYWD3mw/viewform"
                        v-if="lead.spanishTestDone===null"
                        class="my-6"
                      >
                        Do your test
                        <v-icon right dark>mdi-open-in-new</v-icon>
                      </v-btn>
                    </v-card>
                    <div flat v-if="lead.spanishTestDone!==null" class="align-self-center">
                      <v-icon color="ppc_darkgreen" class="align-self-center">mdi-check</v-icon>
                      <strong>Thank you for doing the test!</strong>
                    </div>
                    <caption v-else width="max-content">To prepare your teacher</caption>
                  </v-card>
                </v-card>
                <div class="d-flex flex-row justify-center align-md-end mb-5 flex-wrap">
                  <v-card flat>
                    <v-card-subtitle><v-icon color="ppc_grey">mdi-calendar</v-icon>{{getDateFromTimestamp(application.applied)}}</v-card-subtitle>
                    <v-card-subtitle><v-icon color="ppc_grey">mdi-application</v-icon>{{application.id}}</v-card-subtitle>
                  </v-card>
                  <v-spacer></v-spacer>
                  <v-btn color="brown lighten-1" :to="{name: 'Invoice', params: { application_id: application.id }}" class="ma-4" :disabled="calcStatus(application.id)>7 && calcStatus(application.id)!==13">
                    <v-icon color="white">mdi-application</v-icon>
                    <span class="white--text">Invoice</span>
                  </v-btn>
                  <v-card-text v-if="calcStatus(application.id) === 13">You find payment methods on your invoice and on our <v-btn x-small href="https://proyectoperucentre.org/payment-methods/" target="_blank">website</v-btn></v-card-text>
                </div>
                <v-expansion-panels
                  hover
                  focusable
                  multiple
                >
                  <v-expansion-panel>
                    <v-expansion-panel-header
                      ripple
                      class="px-0 px-sm-6"
                    >
                      <v-spacer></v-spacer>
                        (click to see/hide details)
                      <v-spacer></v-spacer>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-container fluid 
                          v-for="(service, i) in getServicesApplied(application.id)"
                          :key="i"
                          class="d-flex flex-row flex-wrap pa-0"
                      >
                        <v-card
                            width="100%"
                            flat
                        >
                            <v-card-subtitle class="ppc_pink--text">#{{i+1}} {{service.name}}</v-card-subtitle>
                            <v-card-subtitle>{{service.type}} - {{service.duration}} {{service.duration_text}}</v-card-subtitle>
                        </v-card>
                        <v-card 
                            flat 
                            class="d-flex flex-column flex-wrap mx-3 my-3 ma-md-3"
                            width="max-content"
                            outlined
                            rounded="xl"
                        >
                          <v-card-text class="white">
                              <p v-if="service.min_level_spanish">
                                  <v-card-subtitle class="ppc_darkgreen--text mb-0 pb-0 ml-0 pl-0">Initial Spanish level</v-card-subtitle>
                                  <v-card-text> {{service.min_level_spanish}} </v-card-text>
                                  <v-divider></v-divider>
                              </p>
                              <div v-if="service.desc_acc">
                                  <p
                                      flat
                                  >
                                      <v-card-subtitle class="ppc_darkgreen--text my-0 pa-0 pt-2">Accommodation</v-card-subtitle>
                                      <v-card-text class="pb-0" v-html="service.desc_acc"></v-card-text>
                                  </p>
                              </div>
                              <div  v-if="service.desc_study">
                                  <p
                                      flat
                                  >
                                      <v-card-subtitle class="ppc_darkgreen--text my-0 pa-0 pt-2">Study</v-card-subtitle>
                                      <v-card-text class="pb-0" v-html="service.desc_study"></v-card-text>
                                  </p>
                              </div>
                              <div  v-if="service.desc_project">
                                  <p
                                      flat
                                  >
                                      <v-card-subtitle class="ppc_darkgreen--text my-0 pa-0 pt-2">Project</v-card-subtitle>
                                      <v-card-text class="pb-0" v-html="service.desc_project"></v-card-text>
                                  </p>
                              </div>
                              <div  v-if="service.desc_start">
                                  <p
                                      flat
                                  >
                                      <v-card-subtitle class="ppc_darkgreen--text my-0 pa-0 pt-2">Start</v-card-subtitle>
                                      <v-card-text class="pb-0" v-html="service.desc_start"></v-card-text>
                                  </p>
                              </div>
                              <div  v-if="service.desc_incl">
                                  <p
                                      flat
                                  >
                                      <v-card-subtitle class="ppc_darkgreen--text my-0 pa-0 pt-2">Includes</v-card-subtitle>
                                      <v-card-text class="pb-0" v-html="service.desc_incl"></v-card-text>
                                  </p>
                              </div>
                          </v-card-text>
                        </v-card>
                        <v-card 
                            flat
                            width="max-content"
                            class="d-flex flex-column flex-wrap mx-3 my-3 ma-md-3"
                            v-if="service.allowedStartDays !== null"
                            outlined
                            rounded="xl"
                        >
                            <v-card-title class="white">Period</v-card-title>
                            <v-card-text class="flex ma-0 px-5 white">
                                <v-text-field
                                label="from"
                                prepend-icon="mdi-calendar"
                                :value="formattedDate(service.start) || 'to be planned'"
                                disabled
                                ></v-text-field>
                                <v-text-field
                                label="until"
                                prepend-icon="mdi-calendar"
                                :value="formattedDate(service.end) || 'to be planned'"
                                disabled
                                ></v-text-field>
                            </v-card-text>
                        </v-card>
                        <!-- radio and options in services -->
                        <span 
                            v-for="(radio_group, i) in radioGroups_filtered(service.id)"
                            :key="i"
                        >
                          <v-card
                              flat
                              class="d-flex flex-column flex-wrap mx-3 my-3 ma-md-3"
                              width="max-content"
                              outlined
                              rounded="xl"
                          >
                              <v-card-title>
                              {{radio_group.radio_group_name}}
                              </v-card-title>
                              <v-card-text>
                                  <v-list>
                                      <v-list-item>
                                          <v-list-item-icon class="mr-2">
                                              <v-icon color="ppc_darkgreen">mdi-checkbox-marked-circle-outline</v-icon>
                                          </v-list-item-icon>
                                          <v-list-item-content>
                                              {{ radio_group.radio_group_value }}
                                          </v-list-item-content>
                                      </v-list-item>
                                  </v-list>
                              </v-card-text>
                          </v-card>
                        </span>
                        <v-card 
                            v-if="options_filtered_selected(service.id).length > 0"
                            flat
                            class="d-flex flex-column flex-wrap mx-3 my-3 ma-md-3"
                            width="max-content"
                            outlined
                            rounded="xl"
                        >
                          <v-card-title>
                              Selected
                          </v-card-title>
                          <v-card-text>
                              <v-list>
                                  <v-list-item  
                                      v-for="(option, i) in options_filtered_selected(service.id)"
                                      :key="i"
                                  >
                                      <v-list-item-icon class="mr-2">
                                          <v-icon color="ppc_darkgreen">mdi-checkbox-marked-circle-outline</v-icon>
                                      </v-list-item-icon>
                                      <v-list-item-content>
                                          {{ option.option_name }}
                                      </v-list-item-content>
                                  </v-list-item>
                              </v-list>
                          </v-card-text>
                        </v-card>
                      </v-container>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card>
            </div>
          </v-card-text>
        </v-card>
        <v-card
          flat
          class="d-flex flex-row flex-wrap"
          :disabled="!statusLoggedIn"
        >
          <v-toolbar 
            width="100%"
            color="ppc_darkgreen"
            style="color: white;"
            flat
          >
            <v-toolbar-title>Application Form</v-toolbar-title>
            <v-spacer></v-spacer>
            <!-- <v-btn
              icon
              @click="dialog_profile=false"
            >
              <v-icon color="white">mdi-close</v-icon>
            </v-btn> -->
          </v-toolbar>
          <v-card class="ma-5">
            <v-card-title>Privacy Statement</v-card-title>
            <v-card-text>
              At Proyecto Peru, we are committed to protecting your privacy. 
              We do not sell, rent, or distribute client information to third parties without your consent. 
              Access to your data is limited to authorized personnel only, and we implement measures to ensure its security. 
              You have the right to access, correct, or delete your information at any time. 
              For any queries, please contact us at info@proyectoperucentre.org.
            </v-card-text>
          </v-card>
          <v-card
            elevation="3" 
            class="ma-sm-3 ma-md-5 pa-5 md12"
            width="400px"
          >
            <v-card-title><v-icon size="20" class="mr-2">fa-globe</v-icon>Where do you come from?
              <v-icon 
                color="ppc_darkgreen"
                v-if="lead.nationality_id > 0"
              >
                mdi-check
              </v-icon>
            </v-card-title>
            <v-card-text class="d-flex">
              <v-select
                @change="changeLeadValue('nationality_id', $event.id)"
                return-object
                :items="$store.state.itemsNationality"
                item-text="nationality"
                item-value="id"
                :value="lead.nationality_id"
                :menu-props="{ auto: true }"
                label="select your country"
                single-line
                validate-on-blur
              >
              </v-select>
            </v-card-text>
          </v-card>
          <v-card 
            elevation="3" 
            class="ma-sm-3 ma-md-5 pa-5 md12"
          >
            <v-card-title>
              <v-icon size="20" class="mr-2">mdi-gender-male-female</v-icon>
              What is your gender?
            </v-card-title>
            <v-card-text class="d-flex">
              <v-radio-group
                cols="12"
                column
                :value="lead.gender"
                @change="changeLeadValue('gender', $event)"
              >
                <v-radio
                  label="Female"
                  value="Female"
                  class="my-0 py-0"
                ></v-radio>
                <v-radio
                  label="Male"
                  value="Male"
                  class="my-0 py-0"
                ></v-radio>
              </v-radio-group>
              <v-icon 
                color="ppc_darkgreen"
                v-if="lead.gender === 'Male' || lead.gender === 'Female'"
              >
                mdi-check
              </v-icon>
            </v-card-text>
          </v-card>
          <v-card
            elevation="3" 
            class="pa-5 my-2 ma-sm-3 ma-md-5 md-12"
          >
            <v-card-title>When were you born?</v-card-title>
            <v-menu 
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field 
                  :value="lead.birthdate"
                  label="yyyy-mm-dd"
                  v-on='on' 
                  v-bind="attrs"
                  prepend-icon="mdi-cake-variant ppc_darkgreen--text"
                  clearable
                  @click:clear="lead.birthdate=null"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker 
                v-model='lead.birthdate'
                @change="changeLeadValue('birthdate', $event)"
                color='ppc_darkgreen'
                scrollable
              ></v-date-picker>
            </v-menu>
          </v-card>
          <v-card
            elevation="3" 
            class="ma-sm-3 ma-md-5 pa-5 md12"
          >
            <v-card-title>
              In case you take Homestay, we would like to know your preferences, so we can pick the best family for you:
            </v-card-title>
            <v-card flat class="d-flex flex-row flex-wrap">
              <div class="d-flex ma-2" style="width:480px">
                <v-radio-group
                  column
                  :value="lead.food_preference"
                  @change="changeLeadValue('food_preference', $event)"
                  prepend-icon="mdi-food-variant"
                >
                  <v-radio
                    label="I am not vegetarian neither vegan"
                    value="I am vegetarian neither vegan"
                    class="my-0 py-0"
                  ></v-radio>
                  <v-radio
                    label="I am vegetarian"
                    value="I am vegetarian"
                    class="my-0 py-0"
                  ></v-radio>
                  <v-radio
                    label="I am vegan"
                    value="I am vegan"
                    class="my-0 py-0"
                  ></v-radio>
                </v-radio-group>
                <v-icon 
                  color="ppc_darkgreen"
                  v-if="lead.food_preference && lead.food_preference !== 'Not known'"
                >
                  mdi-check
                </v-icon>
              </div>
              <div class="d-flex ma-2" style="width:320px">
                <v-radio-group
                  column
                  :value="lead.pets_preference"
                  @change="changeLeadValue('pets_preference', $event)"
                  prepend-icon="mdi-dog"
                >
                  <v-radio
                    label="I do not mind pets"
                    value="I do not mind pets"
                    class="my-0 py-0"
                  ></v-radio>
                  <v-radio
                    label="No pets please"
                    value="No pets please"
                    class="my-0 py-0"
                  ></v-radio>
                </v-radio-group>
                <v-icon 
                  color="ppc_darkgreen"
                  v-if="lead.pets_preference && lead.pets_preference !== 'Not known'"
                >
                  mdi-check
                </v-icon>
              </div>
            </v-card>
          </v-card>
          <v-card 
            elevation="3" 
            class="ma-sm-3 ma-md-5 pa-5 md12"
          >
            <v-card-title>
              <v-icon size="20" class="mr-2">mdi-cellphone</v-icon>
              What is your phone number?
            </v-card-title>
            <v-card-text class="d-flex">
              <v-text-field
                label="Mobile phone"
                :value="lead.phone"
                @change="changeLeadValue('phone', $event)"
                clearable
              ></v-text-field>
              <v-icon 
                color="ppc_darkgreen"
                v-if="lead.phone"
              >
                mdi-check
              </v-icon>
            </v-card-text>
            <v-card-text>
              For sending information on WhatsApp <br>about our activities (not for propaganda)
            </v-card-text>
          </v-card>
          <v-card 
            elevation="3" 
            class="ma-sm-3 ma-md-5 pa-5 md12"
          >
            <v-card-title>
              <v-icon size="20" class="mr-2">mdi-alarm</v-icon>
              Emergency Contact
            </v-card-title>
            <v-card-text class="d-flex flex-column">
              <v-text-field
                label="Name"
                :value="lead.ice_full_name"
                @change="changeLeadValue('ice_full_name', $event)"
                clearable
              ></v-text-field>
              <v-icon 
                color="ppc_darkgreen"
                v-if="lead.ice_full_name"
              >
                mdi-check
              </v-icon>
              <v-text-field
                label="Email"
                :value="lead.ice_email"
                @change="changeLeadValue('ice_email', $event)"
                clearable
              ></v-text-field>
              <v-icon 
                color="ppc_darkgreen"
                v-if="lead.ice_email"
              >
                mdi-check
              </v-icon>
              <v-text-field
                label="Phone"
                :value="lead.ice_phone"
                @change="changeLeadValue('ice_phone', $event)"
                clearable
              ></v-text-field>
              <v-icon 
                color="ppc_darkgreen"
                v-if="lead.ice_phone"
              >
                mdi-check
              </v-icon>
              <v-text-field
                label="Alternative phone"
                :value="lead.ice_phone_alt"
                @change="changeLeadValue('ice_phone_alt', $event)"
                clearable
              ></v-text-field>
              <v-icon 
                color="ppc_darkgreen"
                v-if="lead.ice_phone_alt"
              >
                mdi-check
              </v-icon>
            </v-card-text>
          </v-card>
          <v-card 
            elevation="3" 
            class="ma-sm-3 ma-md-5 pa-5 md12"
          >
            <v-card-title>
              <v-icon size="20" class="mr-2">mdi-help-circle-outline</v-icon>
              Where do you know us from?
            </v-card-title>
            <v-card-text class="d-flex">
              <v-radio-group
                cols="12"
                column
                :value="lead.source_id"
                @change="changeLeadValue('source_id', $event)"
              >
                <v-radio
                  label="Webpage"
                  value='1'
                  class="my-0 py-0"
                ></v-radio>
                <v-radio
                  label="Facebook"
                  value='2'
                  class="my-0 py-0"
                ></v-radio>
                <v-radio
                  label="Instagram"
                  value='4'
                  class="my-0 py-0"
                ></v-radio>
                <v-radio
                  label="Tic Toc"
                  value='5'
                  class="my-0 py-0"
                ></v-radio>
                <v-radio
                  label="LinkedIn"
                  value='6'
                  class="my-0 py-0"
                ></v-radio>
                <v-radio
                  label="Recommendation"
                  value='3'
                  class="my-0 py-0"
                ></v-radio>
              </v-radio-group>
              <v-icon 
                color="ppc_darkgreen"
                v-if="lead.source_id"
              >
                mdi-check
              </v-icon>
            </v-card-text>
          </v-card>
          <v-card class="d-flex flex-column align-start ma-sm-3 ma-md-5 pa-5 md12" elevation="3">
            <v-card-title><v-icon size="20" class="mr-2">mdi-text-box</v-icon>Curriculum Vitea</v-card-title>
            <v-card v-if="getUploadInfoType('cv').length > 0" flat class="mx-auto my-5">
              <v-list>
                <v-list-item-group color="primary">
                  <v-list-item v-for="(file, index) in getUploadInfoType('cv')" :key="index" class="d-flex flex-row flex-wrap">
                    <span class="d-inline-block text-truncate" style="max-width: 180px;">{{ file.name }}</span>
                    <div>
                      <v-btn
                        color="ppc_pink"
                        dark
                        x-small
                        fab
                        class="mx-2 my-0"
                        @click="downloadFile(file.id)"
                      >
                        <v-icon>
                          mdi-download
                        </v-icon>
                      </v-btn>
                      <v-btn
                        color="ppc_pink"
                        dark
                        x-small
                        fab
                        class="mx-2 my-0"
                        @click="deleteFile(file.id)"
                        v-if="!getUploadInfoType('cv')[0].approved"
                      >
                        <v-icon>
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </div>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
              <div v-if="getUploadInfoType('cv')[0].approved" class="align-self-center">
                <v-icon color="ppc_darkgreen">mdi-check</v-icon>
                <strong>CV approved!</strong>
              </div>
            </v-card>
            <div class="d-flex flex-column align-self-center" v-else>
              <v-card flat width="250px">
                <v-file-input 
                  :rules="fileRules"
                  small-chips 
                  show-size 
                  label="Select docx or pdf" 
                  @change="selectFile($event, 'cv')"
                  :disabled="selectFileCV"
                  accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                >
                </v-file-input>
              </v-card>
              <v-spacer></v-spacer>
              <v-card flat class="align-self-center">
                <v-btn 
                  color="success" 
                  dark 
                  small 
                  @click="uploadFile('cv')"
                  class="my-6"
                  :disabled="selectFileCV"
                >
                  Upload cv
                  <v-icon right dark>mdi-cloud-upload</v-icon>
                </v-btn>
              </v-card>
            </div>
            <v-card-text width="max-content">If you do volunteering or internship, <br>we use your cv to introduce you <br>to the project</v-card-text>
          </v-card>
          <v-card class="d-flex flex-column align-start ma-sm-3 ma-md-5 pa-5 md12" elevation="3">
            <v-card-title><v-icon size="20" class="mr-2">mdi-passport</v-icon>Passport Scan</v-card-title>
            <v-card v-if="getUploadInfoType('passport').length > 0" flat class="mx-auto my-5">
              <v-list>
                <v-list-item-group color="primary">
                  <v-list-item v-for="(file, index) in getUploadInfoType('passport')" :key="index" class="d-flex flex-row flex-wrap">
                    <span class="d-inline-block text-truncate" style="max-width: 180px;">{{ file.name }}</span>
                    <div>
                      <v-btn
                        color="ppc_pink"
                        dark
                        x-small
                        fab
                        class="mx-2 my-0"
                        @click="downloadFile(file.id)"
                      >
                        <v-icon>
                          mdi-download
                        </v-icon>
                      </v-btn>
                      <v-btn
                        color="ppc_pink"
                        dark
                        x-small
                        fab
                        class="mx-2 my-0"
                        @click="deleteFile(file.id)"
                        v-if="!getUploadInfoType('passport')[0].approved"
                      >
                        <v-icon>
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </div>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
              <div v-if="getUploadInfoType('passport')[0].approved" class="align-self-center">
                <v-icon color="ppc_darkgreen">mdi-check</v-icon>
                <strong>passport approved!</strong>
              </div>
            </v-card>
            <div class="d-flex flex-column align-self-center" v-else>
              <v-card flat width="250px">
                <v-file-input 
                  :rules="fileRules"
                  small-chips 
                  show-size 
                  label="Select jpeg or png file" 
                  @change="selectFile($event, 'passport')"
                  :disabled="selectFilePassport"
                  accept="image/*"
                >
                </v-file-input>
              </v-card>
              <v-spacer></v-spacer>
              <v-card flat class="align-self-center">
                <v-btn
                  color="success" 
                  dark 
                  small 
                  @click="uploadFile('passport')"
                  class="my-6"
                  :disabled="selectFilePassport"
                >
                  Upload passport
                  <v-icon right dark>mdi-cloud-upload</v-icon>
                </v-btn>
              </v-card>
            </div>
            <v-card-text width="max-content">If you take a tour to Machu Picchu,<br> we need it to reserve your ticket</v-card-text>
          </v-card>
          <v-card class="d-flex flex-column align-start ma-sm-3 ma-md-5 pa-5 md12" elevation="3">
            <v-card-title><v-icon size="20" class="mr-2">mdi-file-document-edit</v-icon>Spanish Test</v-card-title>
            <v-spacer></v-spacer>
            <v-card flat class="align-self-center">
              <v-btn 
                color="success" 
                dark 
                small 
                target="_blank" 
                href="https://docs.google.com/forms/d/e/1FAIpQLScV-3VQDsf8cHMz0ZTl9fTMbw1j-DG4Bth_DrxlXbVuYWD3mw/viewform"
                v-if="lead.spanishTestDone===null"
                class="my-6"
              >
                Do our test here
                <v-icon right dark>mdi-open-in-new</v-icon>
              </v-btn>
            </v-card>
            <div flat v-if="lead.spanishTestDone!==null" class="align-self-center">
              <v-icon color="ppc_darkgreen" class="align-self-center">mdi-check</v-icon>
              <strong>Thank you for doing the test!</strong>
            </div>
            <v-card-text v-else width="max-content">To prepare your teacher, your classes, <br>and select the best project for you</v-card-text>
          </v-card>
          <div class="d-flex flex-row flex-wrap">
            <v-card class="ma-4 pa-6">
              <v-card-title>Your Expectations</v-card-title>
              <v-card-subtitle>What are your expectations and what do you want to achieve from your program according to your services?</v-card-subtitle>
              <v-card-text>
                <v-textarea
                  class="rounded-xl ma-4"
                  v-model="lead.expectations"
                  auto-grow
                  clearable
                  counter
                  outlined
                  label="Expectations (500 max)"
                  :rules="[v => (v || '' ).length <= 500 || 'Experience must be 500 characters or less']"
                  style="min-width: 400px"
                  @change="changeLeadValue('expectations', $event)"
                ></v-textarea>
              </v-card-text>
            </v-card>
            <v-card class="ma-4 pa-6">
              <v-card-title>Your Experience</v-card-title>
              <v-card-subtitle>What experience and/or relevant skills do you have that are suitable for this program?</v-card-subtitle>
              <v-card-text>
                <v-textarea
                  class="rounded-xl ma-4"
                  v-model="lead.experience"
                  auto-grow
                  clearable
                  counter
                  outlined
                  label="Experience (500 max)"
                  :rules="[v => (v || '' ).length <= 500 || 'Experience must be 500 characters or less']"
                  style="min-width: 400px"
                  @change="changeLeadValue('experience', $event)"
                ></v-textarea>
              </v-card-text>
            </v-card>
          </div>
        </v-card>
        <v-card flat class="d-flex justify-center align-center">
          <v-btn
            color="primary"
            href="https://proyectoperucentre.org/"
          >
            Back to the website
          </v-btn>
        </v-card>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import getDateFromTimestamp from '../mixins/getDateFromTimestamp';
import compare from '../mixins/compare';
import getServicesApplied from '../mixins/getServicesApplied';
import formattedDate from '../mixins/formattedDate';
import radioGroups_filtered from '../mixins/radioGroups_filtered';
import zlib from 'zlib';
import dayjs from 'dayjs';
import dayjsBusinessDays from 'dayjs-business-days';
import options_filtered_selected from '../mixins/options_filtered_selected';
dayjs.extend(dayjsBusinessDays);

export default {
  data () {
    return {
      rendererKeyPanelHeader: Math.random(),
      rendererKeyDateStart: Math.random(),
      rendererKeyDateEnd: Math.random(),
      rendererKeySlider: Math.random(),
      rendererKeyTotalPrice: Math.random(),
      rendererKeyUploadPanels: Math.random(),
      startDate: false,
      date: null,
      nowDate: new Date().toISOString().slice(0,10),
      type: null,
      panel: [],
      types: [],
      status: [],
      select_items: [],
      startDays: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
      endDays: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
      itemsNationality: null,
      // rename file related variables
      currentFile: undefined,
      fileRules: [
        file => !file || file.size < 2e6 || 'File size should be less than 2 MB!'
      ],
      selectFileCV: false,
      selectFilePassport: false, 
      fixedDuration: false,
    }
  },
  mixins: [getDateFromTimestamp, getServicesApplied, compare, formattedDate, radioGroups_filtered, options_filtered_selected],
  computed: {
    loadingAppProgress () {
      return this.$store.getters.loadingAppProgress
    },
    lead () {
      return this.$store.getters.lead
    },
    services () {
      return this.$store.getters.services
    },
    servicesLength () {
      return this.$store.getters.servicesLength
    },
    applications () {
      return this.$store.getters.applications
    },
    statusLoggedIn () {
      return this.$store.getters.statusLoggedIn
    },
    step () {
      return this.$store.getters.step
    },
    uploadInfos () {
      return this.$store.getters.uploadInfos
    },
    progressUpload () {
      return this.$store.getters.progressUpload
    },
    successMessage () {
      return this.$store.getters.successMessage
    },
  },
  async created () {
    this.$store.dispatch('setLoadingAppProgress', true);
    let result = '';
    await this.$store.dispatch('progressUpload', 0);
    result = await this.$store.dispatch('getGeneralSettings');
    if(result) {
      this.stopLoading();
      console.log('created #1 general settings');
    } else {
      await this.$store.dispatch('progressUpload', 20);
      result = await this.$store.dispatch('getTypes');
      if(result) {
        this.stopLoading();
        console.log('created #2 types');
      } else {
          await this.$store.dispatch('progressUpload',40);
          result = await this.$store.dispatch('getAvailableServices');
          if(result) {
            this.stopLoading();
            console.log('created #3 available services');
          } else {
            await this.$store.dispatch('progressUpload', 60);
            result = await this.$store.dispatch('getAvailableOptions');
            if(result) {
              this.stopLoading();
              console.log('created #4 available options');
            } else {
              await this.$store.dispatch('progressUpload', 70);
              result = await this.$store.dispatch('getAvailablePriceTables');
              if(result) {
                this.stopLoading();
                console.log('created #5 available price tables');
              } else {
                await this.$store.dispatch('progressUpload', 80);
                result = await this.$store.dispatch('getAvailableRadioGroups');
                if(result) {
                  this.stopLoading();
                  console.log('created #6 available radio groups');
                } else {
                  await this.$store.dispatch('progressUpload', 100);
                  result = await this.$store.dispatch('getAvailableRadioOptions');
              }
            }
          }
        }
      }
    }
    if (this.$route.query.service > 0) {
      this.select_service(parseInt(this.$route.query.service))
    }
    this.$store.dispatch('setLoadingAppProgress', false);
  },
  // watch: {
  //   servicesLength (newValue, oldValue) {
  //       console.log('servicesLength', newValue, oldValue)
  //       this.checkDepGlobalRadios()
  //   },
  // },
  methods: {
    stopLoading() {
      this.$store.dispatch('successMessage', 'Sorry, there has been a network error. Please contact us through email at info@proyectoperucentre.org');
      // setTimeout(() => { window.location = 'http://proyectoperucentre.org/'; }, 3000);
    },
    // UI actions
    forceRenderer(part) {
      if (part === 'panelHeader') {
        this.rendererKeyPanelHeader = Math.random();
      }
      if (part === 'dateCardStart') {
        this.rendererKeyDateStart = Math.random();
      }
      if (part === 'dateCardEnd') {
        this.rendererKeyDateEnd = Math.random();
      }
      if (part === 'totalPrice') {
        this.rendererKeyTotalPrice = Math.random();
      }
      if (part === 'slider') {
        this.rendererKeySlider = Math.random();
      }
    },
    openDialog_sign_in(payload) {
      this.$store.dispatch('openDialog_sign_in', payload)
    },
    changeStep (payload) {
      this.$store.dispatch('changeStep', payload);
      // this.checkDepGlobalRadios();
    },
    clearStartDate(pos) {
      this.changeServicesValue(pos, 'start', '');
      this.changeServicesValue(pos, 'end', '');
      if (this.services[pos].duration_type !== "fixed") {
        this.changeServicesValue(pos, 'duration', this.services[pos].min_duration);
        this.calcPriceCurrent(pos);
      }
      this.forceRenderer('dateCardEnd');
    },
    clearEndDate(pos) {
      this.changeServicesValue(pos, 'end', '');
      if (this.services[pos].min_duration !== null) {
        this.changeServicesValue(pos, 'duration', this.services[pos].min_duration);
        this.calcPriceCurrent(pos);
      } else {
        this.changeServicesValue(pos, 'duration', null);
        this.calcPriceCurrent(pos);
      }
      this.forceRenderer('dateCardStart');
    },
    disabledEndDate (id, pos) {
      if (id) {
        if (!this.services[pos].service_number) {
          return true;
        }
        if ((this.services[pos].duration_type === "fixed" && this.services[pos].duration_text !== "hour(s)" && this.services[pos].duration_text !== "afternoon" && this.services[pos].duration_text !== "morning") || this.services[pos].duration_type === "weeks") {
          return true;
        }
      }
      return false;
    },
    getMinEndDate (pos) {
      if (this.services[pos].start) {
        if (this.services[pos].min_duration && this.services[pos].duration_type === "businessWeeks") {
          return this.addbusinessWeeks(this.services[pos].start, (this.services[pos].min_duration * 5) - 1);
        }
        if (this.services[pos].min_duration && this.services[pos].duration_type === "businessDays") {
          return this.addbusinessWeeks(this.services[pos].start, (this.services[pos].min_duration) - 1);
        }
        if (this.services[pos].min_duration && this.services[pos].duration_type === "nights") {
          return this.addDays(this.services[pos].start, this.services[pos].min_duration);
        }
        return this.services[pos].start;
      } else {
        return this.nowDate;
      }
    },
    create_select_items (type_id) {
      if (type_id !== null) {
        if (type_id === 7) {
          var result = this.$store.state.available_services.filter((select_item) => {
            return select_item.promo_text;
          });
          return;
        }
        result = this.$store.state.available_services.filter((select_item) => {
          return select_item.type_id === type_id;
        });
        result.sort(this.dynamicSort('name'));
      }
      return result;
    },
    getServicesNotApplied () {
      return this.services.filter(function(select_item) {
          return !select_item.application_id;
        }
      )
    },
    // add selected service
    async select_service (newServiceNr) {
      const date = new Date();
      let idNew = date.getTime();
      let avServ = this.$store.state.available_services.filter(function(select_item) {
        return select_item.service_number === newServiceNr;
      })
      let service = JSON.parse(JSON.stringify(avServ[0]));
      service.id = idNew;
      service.price = 0;
      service.currentStatus = 8;
      service.lead_id = this.lead.id;

      this.addServices(service);

      let posService = this.services.map(function(e) { return e.id; }).indexOf(idNew);
      let option = [];
      //add local depending options
      let avOptions = JSON.parse(JSON.stringify(this.$store.state.available_options)).filter(function(item) {
        return item.available_service_number === newServiceNr;
      })
      for (let i = 0; i < avOptions.length; i++) {
        option = avOptions[i];
        option.services_id = idNew;
        option.selected = (avOptions[i].selected === 'true');
        await this.$store.dispatch('addOptions', option);
      }

      //add local depending radios
      let radio = [];
      let avRadios = JSON.parse(JSON.stringify(this.$store.state.available_radioGroups)).filter(function(item) {
        return item.available_service_number === newServiceNr;
      });
      let parameters = JSON.parse(JSON.stringify(this.$route.query));
      if (!Array.isArray(parameters.radio_group_id)) {
        parameters.radio_group_id = [parameters.radio_group_id];
        parameters.radio_group_value = [parameters.radio_group_value];
        console.log('select_service 1', parameters);
      }
      for (let i = 0; i < avRadios.length; i++) {
        let posParameter = parameters.radio_group_id.indexOf(avRadios[i].radio_group_id.toString());
        console.log('select_service 2', avRadios[i].radio_group_id.toString(), parameters.radio_group_id.indexOf(avRadios[i].radio_group_id.toString()));
        if (posParameter !== -1) {
          console.log('select_service 3', avRadios[i].radio_group_value, posParameter, parameters.radio_group_value[posParameter]);
          avRadios[i].radio_group_value = parameters.radio_group_value[posParameter];
        }
        radio = avRadios[i];
        radio.services_id = idNew;
        await this.$store.dispatch('addRadios', radio);
      }
      this.panel = [posService];
      this.calcPriceCurrent(posService);
      this.changeStep('2');
    },
    remove (serviceId) {
      this.removeOptions(serviceId);
      this.removeRadios(serviceId);
      this.removeServices(serviceId);
    },
    changeAllowedStartDays(service_number) {
      this.startDays = this.$store.state.available_services.filter(function(select_item) {
          return select_item.service_number === service_number;
        }
      )[0].allowedStartDays
    },
    getStartDays(value) {
      const date = dayjs(value);
      const day = date.format("dddd").toLowerCase();
      return this.startDays.includes(day);
    },
    changeAllowedEndDays(service_number) {
      this.endDays = this.$store.state.available_services.filter(function(select_item) {
          return select_item.service_number === service_number;
        }
      )[0].allowedEndDays
    },
    getEndDays(value) {
      const date = dayjs(value);
      const day = date.format("dddd").toLowerCase();
      return this.endDays.includes(day);
    },
    getImage(id) {
      if (this.$store.state.available_images && id) {
        const tmp = this.$store.state.available_images.filter(function(select_item) {
          return select_item.id === id;
          }
        )
        if (tmp[0]) {
          let returnSrc = JSON.parse(zlib.unzipSync(Buffer.from(tmp[0].image, 'base64')));
          return returnSrc;
        }
        return null;
      } else {
        return null
      } 
    },
    calcStatus(application_id) {
      if (application_id > 0 && this.servicesLength > 0) {
        const servicesInApp = this.services.filter(function(select_item) {
          return select_item.application_id === application_id;
        })
        if (servicesInApp.length > 0) {
          return Math.max.apply(Math, servicesInApp.map(function(o) { return o.currentStatus; }));
        } else {
          return 2;
        }
      }
    },
    getStatus(currentStatus) {
      if (this.$store.state.status.length > 0) {
        if (currentStatus > 0) {
          const status = this.$store.state.status.filter(function(select_item) {
            return select_item.id === currentStatus;
          })
          return status[0];
        }
      }
    },
    options_filtered(serviceId) {
      return this.$store.state.options.filter(function(select_item) {
        return select_item.services_id === serviceId;
        }
      )
    },
    radioOptions_filtered(radioGroupId) {
      return this.$store.state.available_radioOptions.filter(function(item) {
        return item.radio_group_id === radioGroupId;
      })
    },
    async calcDates(action, pos, event) {
      await this.changeServicesValue(pos, action, event);
      if (this.services[pos].service_number) {
        if(this.services[pos].duration_type === "businessWeeks") {
          if ((action === 'duration' && this.services[pos].start) || ((action === 'start' && this.services[pos].duration))) {
            this.changeServicesValue(pos, 'end', this.addbusinessWeeks(this.services[pos].start, ((this.services[pos].duration * 5)-1)));
          }
          if (action === 'start' || action === 'end') {
            if (this.services[pos].start && this.services[pos].end) {
              let weeks = ((dayjs(this.services[pos].end).businessDiff(dayjs(this.services[pos].start))+1)/5);
              if (weeks < this.services[pos].min_duration) {
                this.changeServicesValue(pos, 'end', this.addbusinessWeeks(this.services[pos].start, ((this.services[pos].duration * 5)-1)));
              } else {
                this.changeServicesValue(pos, 'duration', Math.ceil(weeks));
              }
            }
          }
        }
        if(this.services[pos].duration_type === "businessDays") {
          if (action === 'start' || action === 'end') {
            if (this.services[pos].start && this.services[pos].end) {
              let days = ((dayjs(this.services[pos].end).businessDiff(dayjs(this.services[pos].start))+1));
              if (days < this.services[pos].min_duration) {
                this.changeServicesValue(pos, 'duration', this.services[pos].min_duration);
                this.changeServicesValue(pos, 'end', null)
              } else {
                this.changeServicesValue(pos, 'duration', days);
              }
            }
          }
        }
        if(this.services[pos].duration_type === "nights") {
          if (action === 'start' || action === 'end') {
            if (this.services[pos].start && this.services[pos].end) {
              let nights = Math.ceil(this.diffDates(this.services[pos].start, this.services[pos].end));
              if (nights < this.services[pos].duration) {
                this.changeServicesValue(pos, 'duration', this.services[pos].min_duration);
                this.changeServicesValue(pos, 'end', null)
              } else {
                this.changeServicesValue(pos, 'duration', nights);
              }
            } else {
              this.changeServicesValue(pos, 'duration', this.services[pos].min_duration);
            }
          }
        }
        if(this.services[pos].duration_type === "fixed") {
          if (action === 'start') {
            if (this.services[pos].duration_text === 'week(s)') {
              this.changeServicesValue(pos, 'end', this.addWeeks(this.services[pos].start, this.services[pos].duration));
            }
            else if (this.services[pos].duration_text === 'morning' || this.services[pos].duration_text === 'afternoon') {
              this.changeServicesValue(pos, 'end', this.services[pos].start);
            }
            else {
              this.changeServicesValue(pos, 'end', this.addDays(this.services[pos].start, this.services[pos].duration - 1));
            }
          }
        }
        if(this.services[pos].duration_type === "weeks") {
          if (action === 'start' || action === 'duration') {
            if (this.services[pos].duration_text === 'week(s)') {
              this.changeServicesValue(pos, 'end', this.addWeeks(this.services[pos].start, this.services[pos].duration));
            }
            else if (this.services[pos].duration_text === 'morning' || this.services[pos].duration_text === 'afternoon') {
              this.changeServicesValue(pos, 'end', this.services[pos].start);
            }
            else {
              this.changeServicesValue(pos, 'end', this.addDays(this.services[pos].start, this.services[pos].duration - 1));
            }
          }
        }
        this.forceRenderer('dateCardStart');
        this.forceRenderer('dateCardEnd');
        this.calcPriceCurrent(pos);
      }
    },
    async calcPriceCurrent(pos) {
      let id = this.services[pos].id;
      if (pos !== null) {
        let servNr = this.services[pos].service_number;
        let avServ = this.$store.state.available_services.filter(function(select_item) {
            return select_item.service_number === servNr;
          }
        )
        let servicePrice = 0;
        let varPrice = 0;
        let discountApplied = 0;
        let result = this.$store.state.available_price_tables.filter(function(select_item) {
          return select_item.service_number === servNr;
        })
        if (result.length > 0) {
          let weeks;
          if (result.length < this.services[pos].duration) {
            weeks = result.length;
          } else {
            weeks = this.services[pos].duration;
          }
          servicePrice = (result.filter(function(item) {
            return item.weeks === weeks;
          }))[0].price;
        }

        let options = this.$store.state.options;
        if (options.length > 0) {
          let i = 0;
          do {
            if (options[i].selected && options[i].services_id === id) {
              servicePrice = servicePrice + options[i].price;
              varPrice = varPrice + options[i].varPrice;
            }
            i++;
          }
          while (options[i]);
        }
        let radioGroups = this.$store.state.radioGroups;
        if (radioGroups.length > 0) {
          let i = 0;
          do {
            let j = 0;
            let avRadioOptions = this.$store.state.available_radioOptions.filter(function(item) {
              return item.radio_group_id === radioGroups[i].radio_group_id;
            })
            do {
              if (avRadioOptions[j].label === radioGroups[i].radio_group_value && radioGroups[i].services_id === id) {
                servicePrice = servicePrice + avRadioOptions[j].price;
                if (avRadioOptions[j].discount_after < this.services[pos].duration && avRadioOptions[j].discount_percentage) {
                  if (avRadioOptions[j].discount_percentage > discountApplied) {
                    discountApplied = avRadioOptions[j].discount_percentage;
                  }
                  varPrice = varPrice + ((avRadioOptions[j].varPrice * avRadioOptions[j].discount_after) + ((avRadioOptions[j].varPrice - (avRadioOptions[j].varPrice * avRadioOptions[j].discount_percentage/100)) * (this.services[pos].duration - avRadioOptions[j].discount_after)))/this.services[pos].duration;
                } else {
                  varPrice = varPrice + avRadioOptions[j].varPrice;
                }
                if (avRadioOptions[j].duration !== null) {
                  this.changeServicesValue(pos, 'duration', avRadioOptions[j].duration)
                }
                if (avRadioOptions[j].min_duration && this.services[pos].duration < avRadioOptions[j].min_duration) {
                  await this.changeServicesValue(pos, 'duration', avRadioOptions[j].min_duration)
                  this.forceRenderer('slider')
                }
              }
              j++;
            }
            while (avRadioOptions[j]);
            i++;
          }
          while (radioGroups[i]);
        }
        if (discountApplied.toFixed(0) > 0) {
          this.$store.dispatch('successMessage', discountApplied.toFixed(0) + '% DISCOUNT APPLIED!');
        }
        if (avServ[0].price_type === 'fixed') {
          this.changeServicesValue(pos, 'servicePrice', avServ[0].price + servicePrice);
        } else {
          this.changeServicesValue(pos, 'servicePrice', (this.services[pos].duration * (avServ[0].varPrice + varPrice)) + servicePrice + avServ[0].price);
        }
        this.forceRenderer('panelHeader');
        this.forceRenderer('totalPrice');
        return Promise.resolve();
      }
    },
    totalPrice() {
      let i = 0;
      let totalPrice = 0;
      if (this.services.length > 0) {
        do {
          if (this.services[i].servicePrice && this.services[i].application_id === null) {
            if (this.services[i].currency ==='$') {
              totalPrice += +this.services[i].servicePrice;
            } else {
              totalPrice += +(this.services[i].servicePrice / this.$store.state.generalSettings[0].currentExchangeRate).toFixed(2);
            }
          }
          i++;
        }
        while (this.services[i]);
      }
      return totalPrice.toFixed(2);
    },


    // Store actions
    addServices: function(payload) {
      this.$store.dispatch('addServices', payload);
    },
    changeServicesValue: function(pos, column, value) {
      const payload = {pos: pos, column: column, value: value}
      this.$store.dispatch('changeServicesValue', payload);
    },
    removeServices: function(payload) {
      this.$store.dispatch('removeServices', payload);
    },
    setOptions: function(option_id, services_id, pos, event) {
      const payload = {
        option_id: option_id, 
        services_id: services_id, 
        event: event,
      };
      this.$store.dispatch('setOptions', payload);
      this.calcPriceCurrent(pos);
    },
    removeOptions: function(payload) {
      this.$store.dispatch('removeOptions', payload);
    },
    setRadios: function(radioGroupId, services_id, pos, event) {
      const payload = {
        radio_group_id: radioGroupId, 
        services_id: services_id,
        event: event,
      };
      let selected = this.radioOptions_filtered(radioGroupId).filter(function(item) {
        return item.label === event;
      })[0];
      if(selected.duration > 0) {
        this.fixedDuration = true;
      } else if (selected.min_duration > 0) {
        this.fixedDuration = false;
        this.changeServicesValue(pos, 'duration', selected.min_duration);
      }
      this.$store.dispatch('setRadios', payload);
      this.calcPriceCurrent(pos);
    },
    removeRadios: function(payload) {
      this.$store.dispatch('removeRadios', payload);
    },
    setGlobalRadios: function(radio_group_id, event) {
      const payload = {id: radio_group_id, event: event};
      this.$store.dispatch('setGlobalRadios', payload);
    },
    removeDepGlobalRadios: function(payload) {
      this.$store.dispatch('removeDepGlobalRadios', payload);
    },
    changeDisplayPets: function(event) {
      this.$store.dispatch('changeDisplayPets', event);
    },
    changeDisplayFood: function(event) {
      this.$store.dispatch('changeDisplayFood', event);
    },
    async changeLeadValue(column, event) {
      const payload = {
        column: column,
        value: event,
      }
      let result = await this.$store.dispatch('changeLeadValue', payload);
      console.log('changeLeadValue', result);
      (result === 'OK') ? this.$store.dispatch('successMessage', 'Succesfully Saved') : this.$store.dispatch('successMessage', 'Something went wrong. Please send an email to info@proyectoperucentre.org');
    },
    changeApplicationComments: function(column, event) {
      this.$store.dispatch('changeApplicationComments', event);
    },
    cvRequired(application_id) {
      let servicesWithCv = this.services.filter(function(select_item) {
          return select_item.requirements.includes('cv') && select_item.application_id === application_id;
        }
      )
      return servicesWithCv.length;
    },
    passportRequired(application_id) {
      let servicesWithPassport = this.services.filter(function(select_item) {
          return select_item.requirements.includes('passport') && select_item.application_id === application_id;
        }
      )
      return servicesWithPassport.length;
    },
    spanishTestRequired(application_id) {
      let servicesWithSpanish = this.services.filter(function(select_item) {
          return select_item.requirements.includes('spanishTest') && select_item.application_id === application_id;
        }
      )
      return servicesWithSpanish.length;
    },
    async submit() {
      if(!this.statusLoggedIn) {
        this.$store.dispatch('successMessage', 'Please sign in or register');
        this.openDialog_sign_in(true);
      } else {
        if (this.getServicesNotApplied().length === 0) {
          await this.select_service (0)
        }
        await this.$store.dispatch('submit', this.totalPrice());
        this.changeStep('3');
      }
      
    },
    priceInDollars (price) {
      return (price/this.$store.state.generalSettings[0].currentExchangeRate).toFixed(2);
    },
    addWeeks(startDate, weeks) {
      let new_date = dayjs(startDate).add((weeks * 7), 'd');
      let day = new_date.format('DD');
      let month = new_date.format('MM');
      let year = new_date.format('YYYY');
      return year + '-' + month + '-' + day
    },
    addWeeksWorkWeek(startDate, weeks) {
      let new_date = dayjs(startDate).add(((weeks * 7) - 3), 'd');
      let day = new_date.format('DD');
      let month = new_date.format('MM');
      let year = new_date.format('YYYY');
      return year + '-' + month + '-' + day
    },
    addDays(startDate, days) {
      let new_date = dayjs(startDate).add(days, 'd');
      let day = new_date.format('DD');
      let month = new_date.format('MM');
      let year = new_date.format('YYYY');
      return year + '-' + month + '-' + day
    },
    diffDates(startDate, endDate) {
      return dayjs(endDate).diff(dayjs(startDate), 'd');
    },
    addbusinessWeeks(startDate, days) {
      let new_date = dayjs(startDate).businessDaysAdd(days, 'd');
      let day = new_date.format('DD');
      let month = new_date.format('MM');
      let year = new_date.format('YYYY');
      return year + '-' + month + '-' + day
    },
    // file related methods
    selectFile(file, type) {
      if (file) {
        console.log('selectFile', file.name)
        if (type === 'cv') {
          this.selectFilePassport = true;
        } else {
          this.selectFileCV = true;
        }
        this.currentFile = file;
        this.$store.dispatch('setFileName', file.name)
      } else {
        this.selectFileCV = false;
        this.selectFilePassport = false;
      }
    },
    uploadFile(type) {
      if (this.currentFile) {
        this.$store.dispatch('showProgressBar', true);

          const reader = new FileReader();
          
          reader.onload = () => {
            const zip = zlib.gzipSync(JSON.stringify(reader.result)).toString('base64');
            const date = new Date();
            const payload = {
              id: date.getTime(),
              lead_id: this.lead.id,
              type: type,
              file: zip,
            }
            if (payload) {
              this.$store.dispatch('addUpload', payload).then(() => {
                this.selectFileCV = false;
                this.selectFilePassport = false;
              })
            }
          }
          if(this.currentFile) {
            reader.readAsDataURL(this.currentFile);
          }
          this.currentFile = undefined;
          this.currentFileName = undefined;
      } else {
        this.$store.dispatch('successMessage', 'Please select a file');
      }
    },
    downloadFile (payload) {
      this.$store.dispatch('downloadFile', payload);
    },
    deleteFile (payload) {
      this.$store.dispatch('deleteFile', payload);
    },
    getUploadInfoType (type) {
      if (this.$store.state.uploadInfos) {
        return this.$store.state.uploadInfos.filter(function(select_item) {
            return select_item.type === type;
          }
        )
      }
    },
  }
}
</script>

<style>
  .v-card__title {
    color: #35b729;
    word-break: normal !important;
  }
  .pos_absolute {
    position: absolute;
  }
  @media only screen and (max-width: 1280px) {
    .v-stepper__content {
      padding: 0 !important;
    }
    .v-expansion-panel-content__wrap {
      padding: 0 !important;
    }
  }
</style>

<style lang="scss">
  @import '@/styles/variables.scss';
</style>